export default __webpack_public_path__ + "static/media/questionJPG.0ea8e037.JPG";